import { accessCriteria } from '../util/authorization/index';
import { authRoles } from './roleGroups';

const DOCUMENT_TITLE = 'Official Depository';

export const ODRoutes = [
  {
    path: '/od',
    name: 'Official Depository',
    meta: {
      title: DOCUMENT_TITLE,
    },
    component: () => import('../views/OfficialDepository.vue'),
    children: [
      {
        path: '/reports',
        name: 'Official Depository - Reports',
        meta: {
          title: DOCUMENT_TITLE,
        },
        component: () => import('../views/OD/Reports.vue'),
      },
      {
        path: 'transactions',
        name: 'Official Depository - Deposits & Vouchers',
        meta: {
          title: DOCUMENT_TITLE,
        },
        component: () => import('../views/OD/Transactions.vue'),
      },
      {
        path: 'browse',
        name: 'Official Depository - Browse',
        meta: {
          title: DOCUMENT_TITLE,
        },
        component: () => import('../views/OD/browse/Browse.vue'),
        children: [
          {
            path: 'departments',
            name: 'Official Depository - Departments',
            meta: {
              title: DOCUMENT_TITLE,
            },
            component: () => import('../views/OD/browse/Departments.vue'),
          },
          {
            path: 'whats',
            name: 'Official Depository - For What',
            meta: {
              title: DOCUMENT_TITLE,
            },
            component: () => import('../views/OD/browse/Whats.vue'),
          },
          {
            path: 'whoms',
            name: 'Official Depository - To Whom',
            meta: {
              title: DOCUMENT_TITLE,
            },
            component: () => import('../views/OD/browse/Whoms.vue'),
          },
          {
            path: 'trusttypes',
            name: 'Official Depository - Trust Types',
            meta: {
              title: DOCUMENT_TITLE,
            },
            component: () => import('../views/OD/browse/TrustTypes.vue'),
          },
        ],
      },
      {
        path: 'utils',
        name: 'Official Depository - Utils',
        meta: {
          title: DOCUMENT_TITLE,
        },
        component: () => import('../views/OD/utils/Utils.vue'),
        children: [
          {
            path: 'interestapportionment',
            name: 'Official Depository - Interest Apportionment',
            meta: {
              title: DOCUMENT_TITLE,
            },
            component: () => import('../views/OD/utils/InterestApportionment.vue'),
          },
          {
            path: 'createfiscalyear',
            name: 'Official Depository - Create New Fiscal Year',
            meta: {
              title: DOCUMENT_TITLE,
            },
            component: () => import('../views/OD/utils/OdCreateFiscalYear.vue'),
          },
        ],
      },
    ],
  },
  {
    path: '/reports/interestapportionment',
    name: 'Official Depository - Interest Apportionment Report',
    component: () => import('../views/OD/utils/InterestApportionmentReport.vue'),
  },
];

ODRoutes.forEach((element, index) => {
  ODRoutes[index].beforeEnter = async (to, from, next) => {
    await accessCriteria(authRoles.ODRead, next);
  };
});

export default ODRoutes;
